import React from "react";

export const Founders = () => {
  return (
    <section
      id="founders"
      data-testid="founders-section"
      className="px-6 md:px-10 py-24 md:py-32 border-t border-black/10"
    >
      <div className="grid grid-cols-12 gap-6 mb-14 md:mb-20">
        <div className="col-span-12 md:col-span-3">
          <div className="font-mono-label text-[11px] text-black/55">§ 06 · The Steward</div>
        </div>
        <div className="col-span-12 md:col-span-9">
          <h2
            data-testid="founders-heading"
            className="font-serif-display text-[44px] md:text-[72px] leading-[1.02] tracking-tight"
          >
            Built by <span className="italic-accent">one hand,</span>
            <br />
            one vision.
          </h2>
        </div>
      </div>

      {/* Single-founder editorial layout */}
      <div className="grid grid-cols-12 gap-10 md:gap-14">
        <div className="col-span-12 md:col-span-4 lg:col-span-3">
          <div
            data-testid="founder-portrait"
            className="relative aspect-[4/5] max-w-[280px] overflow-hidden bg-[#0A0A0A]"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_mera-ecosystem/artifacts/98r63j7j__DSC3242.jpg"
              alt="Marc Madrid — Founder, MERA Technology"
              className="absolute inset-0 w-full h-full object-cover grayscale contrast-[1.05]"
              style={{ objectPosition: "50% 20%" }}
              loading="lazy"
            />
            {/* Stronger bottom gradient for caption legibility */}
            <div
              aria-hidden
              className="absolute inset-x-0 bottom-0 h-3/5 bg-gradient-to-t from-black/90 via-black/50 to-transparent"
            />
            <div className="absolute top-4 left-4 font-mono-label text-[10px] text-white/80">
              01 / 01
            </div>
            <div className="absolute bottom-5 left-5 right-5 font-mono-label text-[10px] text-white/85 leading-relaxed">
              Marc Madrid
              <br />
              <span className="text-white/55">Founder · MERA Technology</span>
            </div>
          </div>
        </div>

        <div
          className="col-span-12 md:col-span-8 lg:col-span-8 md:col-start-5"
          data-testid="founder-bio"
        >
          <div className="font-mono-label text-[10px] text-black/55 mb-4">
            Founder · 2025—present
          </div>
          <h3 className="font-serif-display text-[44px] md:text-[60px] leading-[0.98] tracking-tight">
            Marc Madrid.
          </h3>

          <p className="mt-8 max-w-[680px] text-[17px] leading-relaxed text-black/70">
            Marc Madrid has spent 25 years building enterprise technology at
            Cognizant, AVAAP, Sierra-Cedar, and his own ventures. MERA is the
            company he has always been building toward — ten products, one
            architecture, one belief that technology should serve the human.
          </p>

          {/* Credential strip */}
          <div className="mt-10 pt-6 border-t border-black/10 grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-8">
            {[
              { k: "01", v: "Cognizant", url: "https://www.cognizant.com" },
              { k: "02", v: "AVAAP", url: "https://www.avaap.com" },
              { k: "03", v: "Sierra-Cedar", url: "https://www.sierra-cedar.com" },
              { k: "04", v: "Independent ventures", url: null },
            ].map((c) => (
              <div key={c.v}>
                <div className="font-mono-label text-[10px] text-black/45">{c.k}</div>
                {c.url ? (
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`credential-link-${c.v.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="mt-1 font-serif-display text-[18px] text-black/85 hover:text-black underline decoration-black/20 underline-offset-4 hover:decoration-black/60 transition-colors inline-block"
                  >
                    {c.v}
                  </a>
                ) : (
                  <div className="mt-1 font-serif-display text-[18px] text-black/85">
                    {c.v}
                  </div>
                )}
              </div>
            ))}
          </div>

          <p className="mt-10 font-serif-display italic text-[20px] md:text-[24px] leading-snug text-black/75 max-w-[640px]">
            "Twenty-five years of watching software get faster, louder, and
            further from the people it's meant to serve. MERA is the answer to
            that."
          </p>
        </div>
      </div>
    </section>
  );
};
